<script>
export default {
    name: "BulkOrderMixin",
    methods: {
        getBulkOrders (userId, warehouseId) {
            let data = this.$store.getters["bulkOrder/getBulkOrders"](userId);
            if (data && warehouseId in data) {
                return data[warehouseId];
            }
            return [];
        },
        getNumberOfBulkOrders (userId, warehouseId) {
            return this.getBulkOrders(userId, warehouseId).length;
        },
        getRecipientsOfBulkOrders (userId, warehouseId) {
            let recipients = [];
            this.getBulkOrders(userId, warehouseId)
                .forEach(bulkOrder => {
                    bulkOrder.recipients.forEach(recipient => {
                        if (!recipients.find(r => r.address_id === recipient.address_id)) {
                            recipients.push(recipient);
                        }
                    });
                });
            return recipients;
        },
        addOrderToBulkOrders (userId, warehouseId, order, recipients, message) {
            this.$store.commit("bulkOrder/addOrderToBulkOrders", {
                userId: userId,
                warehouseId: warehouseId,
                order: order,
                recipients: recipients,
                message: message
            })
        },
        removeOrderFromBulkOrders (userId, warehouseId, item) {
            this.$store.commit("bulkOrder/removeOrderFromBulkOrders", {
                userId: userId,
                warehouseId: warehouseId,
                item: item
            });
        },
        removeOrdersFromBulkOrders (userId, warehouseId) {
            this.$store.commit("bulkOrder/removeOrdersFromBulkOrders", {
                userId: userId,
                warehouseId: warehouseId
            });
        }
    }
}
</script>
